import React from "react";

import Placeholder from "components/Placeholder";

import useStyles from "./useStyles";

const InputPlaceholder = () => {
  const classes = useStyles();

  return <Placeholder variant="rect" height={40} className={classes.placeholder} />;
};

export default InputPlaceholder;
